export default __webpack_public_path__ + "static/media/osteo_sitzend.2406d364.jpg";